import React, { useState, useRef } from "react";
import { ReCaptcha } from "react-recaptcha-google";
import { connect } from "react-redux";
import { selectUserState } from "../../selectors/application";
import PrimaryButton from "../../elements/primary-button";
import Input from "../../elements/input";
import Dropdown from "../../elements/dropdown";
import Textarea from "../../elements/textarea";
import BodyText from "../../elements/body-text";
import Checkbox from "../../elements/checkbox";
import PropTypes from "prop-types";
import "./style.scss";
import InputPhoneNumber from "../../elements/InputPhoneNumber";

const B2BContactForm = ({
  user,
  countryTip,
  emailTipText,
  countryRequiredError,
  messageRequiredError,
  firstnameLabel,
  lastnameLabel,
  firstnameRequired,
  lastnameRequired,
  emailRequiredError,
  emailErrorTipText,
  fleetSize,
  numberOfEmployees,
  phoneNumberLabel,
  phoneMissingMessage,
  phoneWarningMessage,
  phoneAreaLabel,
  companyLabel,
  companyMissingMessage,
  fleetSizeLabel,
  fleetSizeMissingMessage,
  numberOfEmployeesLabel,
  numberOfEmployesMissingMessage,
  countries,
  countryVisible,
  messageTipText,
  hasCaptcha,
  captchaSiteKey,
  hasError,
  errorMessage,
  button,
  disclaimer,
  checkboxLabel,
  cityLabel,
  cityLabelMissingMessage,
  onSubmitForm = () => {}
}) => {
  const [captchaValidated, setCaptchaValidated] = useState(!hasCaptcha);
  // const [captchaIsValid, setCapthchaIsValid] = useState();
  const [emailEntered, setEmailEntered] = useState(user?.email);
  const [emailEnteredIsValid, setEmailEnteredIsValid] = useState(true);
  const [firstnameEntered, setFirstnameEntered] = useState(user?.firstName);
  const [firstnameShowError, setFirstnameShowError] = useState();
  const [lastnameEntered, setLastnameEntered] = useState(user?.lastName);
  const [lastnameShowError, setLastnameShowError] = useState();
  const [emailEnteredShowError, setEmailEnteredShowError] = useState(false);
  const [emailErrorMessage, setEmailErrorMessage] = useState();
  const [numberEmployeesSelected, setNumberEmployeesSelected] = useState();
  const [numberEmployeesShowError, setNumberEmployeesShowError] = useState();
  const [fleetSizeSelected, setFleetSizeSelected] = useState();
  const [fleetSizeShowError, setFleetSizeShowError] = useState();
  const [companyNameEntered, setCompanyNameEntered] = useState();
  const [companyShowError, setCompanyShowError] = useState();
  const [cityEntered, setCityEntered] = useState();
  const [cityShowError, setCityShowError] = useState();
  const [countrySelected, setCountrySelected] = useState();
  const [countryShowError, setCountryShowError] = useState();
  const [messageEntered, setMessageEntered] = useState();
  const [messageShowError, setMessageShowError] = useState();
  const [phoneNumberEntered, setPhoneNumberEntered] = useState(user?.mobileNo);
  const [phoneNumberPrefixEntered, setPhoneNumberPrefixEntered] = useState(user?.mobileNoCountryCode);
  const [phoneIsValid, setPhoneIsValid] = useState(true);
  const [submitTimestamp, setSubmitTimestamp] = useState();
  const [agreedToConsent, setAgreedToConsent] = useState(false);
  const [consentShowError, setConsentShowError] = useState();

  let captcha;
  const captchaContainer = useRef();

  const onLoadRecaptcha = () => captcha && captcha.reset();

  const verifyCallback = (recaptchaToken, grecaptcha) => {
    // Here you will get the final recaptchaToken!!!
    getCaptchFrame().style = "";

    if (recaptchaToken) {
      setCaptchaValidated(true);
    } else {
      grecaptcha.reset();
    }
  };

  const onInputChange = (event, isValid) => {
    setEmailEntered(event.target.value);
  };

  const onInputEmailBlur = (evt, isValid) => {
    setEmailEntered(evt.target.value);
    if (evt.target.value) {
      setEmailEnteredIsValid(isValid);
      if (!isValid) {
        setEmailErrorMessage(emailErrorTipText.value);
        setEmailEnteredIsValid(true);
      }
    }
  };

  const onfirstnameChange = event => {
    setFirstnameEntered(event.target.value);
  };

  const onLastnameChange = event => {
    setLastnameEntered(event.target.value);
  };

  const onPhoneChange = (area, number, isValid) => {
    setPhoneNumberPrefixEntered(area);
    setPhoneNumberEntered(number);
    setPhoneIsValid(isValid);
  };

  const onCompanyNameChange = evt => {
    setCompanyNameEntered(evt.target.value);
  };
  const onCityChange = evt => {
    setCityEntered(evt.target.value);
  };
  const onNbrEmplyeesDropdownChange = value => {
    setNumberEmployeesSelected(value);
  };

  const onFleetSizeDropdownChange = value => {
    setFleetSizeSelected(value);
  };

  const onCountryDropdownChange = value => {
    setCountrySelected(value);
  };

  const onTextAreaChange = event => {
    setMessageEntered(event.target.value);
  };

  const onConsentChange = value => {
    setAgreedToConsent(value);
  };

  const submitFormIsValid = () => {
    return (
      emailEnteredIsValid && firstnameEntered && lastnameEntered && phoneIsValid && companyNameEntered && ((countrySelected && countryVisible) || !countryVisible) && fleetSizeSelected && numberEmployeesSelected && messageEntered && ((captchaValidated && hasCaptcha) || !hasCaptcha) && agreedToConsent
    );
  };

  const onSubmitFormData = event => {
    setSubmitTimestamp(new Date());
    if (submitFormIsValid()) {
      let data = {
        firstname: firstnameEntered,
        lastname: lastnameEntered,
        email: emailEntered,
        areaCode: phoneNumberPrefixEntered,
        phonenNumber: phoneNumberEntered,
        city: cityEntered,
        company: companyNameEntered,
        country: countrySelected,
        fleetSize: fleetSizeSelected,
        numberOfEmployees: numberEmployeesSelected,
        message: messageEntered
      };
      onSubmitForm(event, data);
    } else {
      if (!countrySelected) {
        setCountryShowError(true);
      }
      if (countrySelected?.code === "default") {
        setCountryShowError(true);
      }

      if (!firstnameEntered) {
        setFirstnameShowError(true);
      }

      if (!lastnameEntered) {
        setLastnameShowError(true);
      }

      if (!emailEntered) {
        setEmailEnteredShowError(true);

        setEmailErrorMessage(emailRequiredError.value);
      } else if (!emailEnteredIsValid) {
        setEmailErrorMessage(emailErrorTipText.value);
        setEmailEnteredIsValid(true);
      }
      if (!companyNameEntered) {
        setCompanyShowError(true);
      }
      if (!cityEntered) {
        setCityShowError(true);
      }
      if (!fleetSizeSelected) {
        setFleetSizeShowError(true);
      }
      if (fleetSizeSelected?.code === "default") {
        setFleetSizeShowError(true);
      }
      if (!numberEmployeesSelected) {
        setNumberEmployeesShowError(true);
      }
      if (numberEmployeesSelected?.code === "default") {
        setNumberEmployeesShowError(true);
      }

      if (!messageEntered) {
        setMessageShowError(true);
      }

      if (!captchaValidated && hasCaptcha) {
        getCaptchFrame().style = "padding: 2px 1px 1px 2px; background: red;";
      }

      if (!agreedToConsent) {
        setConsentShowError(true);
      }
    }
  };

  const getCaptchFrame = () => {
    return captchaContainer.current.querySelector(".captcha iframe");
  };

  return (
    <form
      className={"b2b-form"}
      //  onSubmit={event => handleSubmit(event)}
    >
      <Input
        {...{
          label: firstnameLabel.value,
          value: firstnameEntered,
          maxLength: 25,
          warningMessage: firstnameRequired.value,
          showError: firstnameShowError,
          onChange: event => onfirstnameChange(event),
          onFocus: () => setFirstnameShowError(false)
        }}
      />
      <Input
        {...{
          label: lastnameLabel.value,
          warningMessage: lastnameRequired.value,
          value: lastnameEntered,
          maxLength: 25,
          showError: lastnameShowError,
          onChange: event => onLastnameChange(event),
          onFocus: () => setLastnameShowError(false)
        }}
      />
      <Input
        {...{
          label: emailTipText.value,
          value: emailEntered,
          warningMessage: emailErrorMessage,
          showError: emailEnteredShowError || !emailEnteredIsValid,
          type: "email",
          onChange: (event, isValid) => onInputChange(event, isValid),
          onFocus: () => setEmailEnteredShowError(false),
          onBlur: (evt, isValid) => onInputEmailBlur(evt, isValid)
        }}
      />
      <InputPhoneNumber
        phoneArea={{
          label: phoneAreaLabel?.value,
          value: phoneNumberPrefixEntered
        }}
        phoneNumber={{
          label: phoneNumberLabel?.value,
          value: phoneNumberEntered
        }}
        warningMessage={phoneWarningMessage?.value}
        missingMessage={phoneMissingMessage?.value}
        onInit={(area, number, isValid) => onPhoneChange(area, number, isValid)}
        onChange={(area, number, isValid) => onPhoneChange(area, number, isValid)}
        submitTimestamp={submitTimestamp}
      />
      <Input
        {...{
          label: companyLabel?.value,
          warningMessage: companyMissingMessage?.value,
          value: companyNameEntered,
          showError: companyShowError,
          onChange: event => onCompanyNameChange(event),
          onFocus: () => setCompanyShowError(false)
        }}
      />

      <Dropdown
        className="subject"
        {...{
          ...fleetSize,
          placeholder: fleetSizeLabel?.value,
          warningMessage: fleetSizeMissingMessage?.value,
          showError: fleetSizeShowError,
          onChange: value => onFleetSizeDropdownChange(value),
          onFocus: () => setFleetSizeShowError(false)
        }}
      />

      <Dropdown
        className="subject"
        {...{
          ...numberOfEmployees,
          placeholder: numberOfEmployeesLabel?.value,
          warningMessage: numberOfEmployesMissingMessage?.value,
          showError: numberEmployeesShowError,
          onChange: value => onNbrEmplyeesDropdownChange(value),
          onFocus: () => setNumberEmployeesShowError(false)
        }}
      />

      {countryVisible && (
        <Dropdown
          className="country"
          {...{
            ...countries,
            placeholder: countryTip.value,
            warningMessage: countryRequiredError.value,
            showError: countryShowError,
            onChange: value => onCountryDropdownChange(value),
            onFocus: () => setCountryShowError(false)
          }}
        />
      )}
      <Input
        {...{
          label: cityLabel?.value,
          warningMessage: cityLabelMissingMessage?.value,
          value: cityEntered,
          showError: cityShowError,
          onChange: event => onCityChange(event),
          onFocus: () => setCityShowError(false)
        }}
      />
      <Textarea
        {...{
          label: messageTipText?.value,
          warningMessage: messageRequiredError?.value,
          showError: messageShowError,
          onChange: event => onTextAreaChange(event),
          onFocus: () => setMessageShowError(false)
        }}
      />

      <Checkbox
        {...{
          label: checkboxLabel?.value,
          error: consentShowError,
          onChange: value => onConsentChange(value)
        }}
      />

      {hasCaptcha && (
        <div className="captcha" ref={captchaContainer}>
          <ReCaptcha
            ref={el => {
              captcha = el;
            }}
            size="normal"
            data-theme="dark"
            theme="dark"
            render="explicit"
            sitekey={captchaSiteKey}
            onloadCallback={onLoadRecaptcha}
            verifyCallback={captchaToken => {
              verifyCallback(captchaToken, captcha);
            }}
          />
        </div>
      )}

      {errorMessage && hasError && (
        <div
          className="error-message"
          dangerouslySetInnerHTML={{
            __html: errorMessage
          }}
        />
      )}

      {button != null && (
        <PrimaryButton
          {...{
            ...button,
            callback: event => onSubmitFormData(event)
          }}
        />
      )}
      {disclaimer.value !== "" && <BodyText html={disclaimer.value} className="disclaimer" />}
    </form>
  );
};

B2BContactForm.propTypes = {
  countryTip: PropTypes.object,
  subjectTip: PropTypes.object,
  emailTipText: PropTypes.object,
  countryRequiredError: PropTypes.object,
  subjectRequiredError: PropTypes.object,
  messageRequiredError: PropTypes.object,
  firstnameLabel: PropTypes.object,
  lastnameLabel: PropTypes.object,
  firstnameRequired: PropTypes.object,
  lastnameRequired: PropTypes.object,
  emailRequiredError: PropTypes.object,
  emailErrorTipText: PropTypes.object,
  subject: PropTypes.object,
  countries: PropTypes.object,
  countryVisible: PropTypes.bool,
  messageTipText: PropTypes.object,
  hasCaptcha: PropTypes.bool,
  captchaSiteKey: PropTypes.string,
  hasError: PropTypes.bool,
  errorMessage: PropTypes.object,
  button: PropTypes.object,
  disclaimer: PropTypes.object,
  onSubmitForm: PropTypes.func
};

const mapStateToProps = state => ({
  user: selectUserState(state)
});
export default connect(mapStateToProps)(B2BContactForm);
